// 用户报名
export const USER_POST_SIGNUP = 'USER_POST_SIGNUP';

// ----------------------
// 获取图片验证码
export const USER_GET_CAPTCHA = 'USER_GET_CAPTCHA';
// 验证图片验证码
export const USER_VERIFY_CAPTCHA = 'USER_VERIFY_CAPTCHA';

export const USER_POST_LOGIN = 'USER_POST_LOGIN';
export const USER_SET_PROFILE = 'USER_SET_PROFILE';
// export const USER_SAVE_USERNAME = 'USER_SAVE_USERNAME';
export const USER_GET_PROFILE = 'USER_GET_PROFILE';

// 填写用户基本信息
export const USER_SET_BASICINFO = 'USER_SET_BASICINFO';

// 获取账号通讯信息
export const USER_GET_COMMUNICATION = 'USER_GET_COMMUNICATION';
export const USER_SET_COMMUNICATION = 'USER_SET_COMMUNICATION';
// 退出
export const USER_DELETE_LOGOUT = 'USER_DELETE_LOGOUT';

// 获取上传图片的 policy
export const USER_GET_IMG_CONFIG = 'USER_GET_IMG_CONFIG';
export const USER_SET_IMG_CONFIG = 'USER_SET_IMG_CONFIG';

// 重置状态
export const USER_RESET_STATE = 'USER_RESET_STATE';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_user.js